import styled from "styled-components";
import { MarketingSpacing } from "../../../components/ReusableStyledComponents/MarketingSpacing";
import { media } from "../../../theme/theme";

export const PostPreviewGrid = styled.div`
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
   

    > div {
        width: 100%;
        margin-bottom: 65px;

        ${media.custom(590)} {
            width: calc(50% - 20px);
        }

        ${media.custom(830)} {
            width: calc(33.3% - 20px);
            margin-bottom: 94px;
        }
    }
`;

export const BlogPageHeaderComponentWrapper = styled.div`
    background: #F5F8FF;
    padding: 0 0 64px;

    ${media.custom(600)} {
        padding: 0 0 64px;
    }

    ${media.custom(1200)} {
        padding: 44px 0 94px;
    }
`;

export const BlogGenericWrapper = styled.div`
    max-width: 1400px;
    margin: 0 auto;
    width: 100%;
    ${MarketingSpacing}
`;

export const TagDisplayContainer = styled.div`
    min-height: 52px;
    position: relative;
    z-index: 2;
`;